import gql from "graphql-tag";

export const GET_IDCC_LIST = gql`
  query GetIdccList(
    $take: Int
    $skip: Int
    $where: IdccWhereInput
    $like: IdccWhereInput
    $orderBy: [IdccWhereInput]
  ) {
    getIdccList(
      take: $take
      skip: $skip
      where: $where
      like: $like
      orderBy: $orderBy
    ) {
      count
      data {
        id
        code
        label
      }
    }
  }
`;
